import * as React from 'react';
import { RateChangeAcceptType } from 'eTip--common';
import { CheckBox } from 'common--design-library';
import { translation, translationForTipos } from 'easit--localization';
import classNames from 'classnames';

export interface IRateAdjustmentOptionsProps {
    selectedOption: RateChangeAcceptType;
    selectOption: (selected: RateChangeAcceptType) => void;
    isPercentAllowed: boolean;
    percentageValue?: number;
    changePercentageValue?: (value: number) => void;
    isEnabledUI: boolean;
}

export const RateAdjustmentOptions: React.FC<IRateAdjustmentOptionsProps> = (props) => {
    return <div className="rate-change-options">
        <div className={classNames("rate-change-option", __IsMTSTipos__ ? "mb-1" : null)}>
            <CheckBox isChecked={props.selectedOption === RateChangeAcceptType.RateIncrease}
                onChangehandler={() => { props.isEnabledUI && props.selectOption(RateChangeAcceptType.RateIncrease); }}
                isDisabled={!props.isEnabledUI}
            >
                {translation().coupon_liveAcceptHigerRate}
            </CheckBox>
        </div>
        {props.isPercentAllowed &&
            <div className={classNames("d-flex rate-change-option", __IsMTSTipos__ ? "mb-1" : null)}>
                <CheckBox isChecked={props.selectedOption === RateChangeAcceptType.RatePercentageChange}
                    onChangehandler={() => { props.isEnabledUI && props.selectOption(RateChangeAcceptType.RatePercentageChange); }}
                    isDisabled={!props.isEnabledUI}
                >
                    {translationForTipos().coupon_liveAcceptRateInInterval}
                </CheckBox>
                <select className="rate-adjustments-value"
                    value={`${props.percentageValue}`}
                    onChange={(input) => {
                        props.isEnabledUI && props.changePercentageValue(parseInt(input.target.value, 10));
                    }}
                    disabled={!props.isEnabledUI}
                >
                    <option value="5">5%</option>
                    <option value="10">10%</option>
                    <option value="20">20%</option>
                    <option value="30">30%</option>
                    <option value="50">50%</option>
                </select>
            </div>
        }
        <div className="rate-change-option">
            <CheckBox isChecked={props.selectedOption === RateChangeAcceptType.AnyRate}
                onChangehandler={() => { props.isEnabledUI && props.selectOption(RateChangeAcceptType.AnyRate); }}
                isDisabled={!props.isEnabledUI}
                roleForTest="accept-rate__item--any-change"
            >
                {translation().coupon_liveAcceptAllRates}
            </CheckBox>
        </div>
    </div>
}